// Hand-curated metadata for examples-build.
// Future: tags will move into each example's docs.json (in xyd-js/examples).
// For now keep them here so we can iterate without touching that repo.

export const popularTags: string[] = [
  "OpenAPI",
  "GraphQL",
  "Auth",
  "MCP",
  "CLI",
  "React",
  "Navigation",
  "Internationalization",
];

// slug → tags. Slugs missing from this map render with no tags.
export const tagsBySlug: Record<string, string[]> = {
  abtesting: ["A/B testing", "GrowthBook"],
  "access-control-edge-custom-page-ui": ["Auth", "Edge"],
  "access-control-edge-jwt": ["Auth", "JWT", "Edge"],
  "access-control-edge-oauth": ["Auth", "OAuth", "Edge"],
  "access-control-edge-password": ["Auth", "Edge"],
  "access-control-jwt": ["Auth", "JWT"],
  "access-control-oauth": ["Auth", "OAuth"],
  "ask-ai": ["AI"],
  basename: ["Routing"],
  "custom-icons": ["Theming"],
  "custom-js": ["Theming"],
  graphql: ["GraphQL", "API"],
  graphviz: ["Diagrams"],
  i18n: ["Internationalization"],
  "i18n-catalog-overrides": ["Internationalization"],
  "i18n-catalogs": ["Internationalization"],
  "i18n-catalogs-custom-paths": ["Internationalization"],
  "i18n-overrides": ["Internationalization"],
  "i18n-overrides-flat": ["Internationalization"],
  mcp: ["MCP", "AI"],
  "monday-clone": ["GraphQL", "Showcase"],
  "navigation-dropdown-menu": ["Navigation"],
  "navigation-segments-logoTrailing": ["Navigation"],
  "hashicorp-clone": ["Theming", "Showcase"],
  "openai-clone": ["OpenAPI", "Showcase"],
  openapi: ["OpenAPI", "API"],
  opencli: ["CLI", "API"],
  "opencli-orbit": ["CLI", "API"],
  "react-components": ["React"],
  "sidebar-as-toc": ["Navigation"],
  syntaxhighlight: ["Theming"],
  "vite-custom-configuration": ["Vite"],
};

// Pinned-first featured slots. Slugs listed here always appear at the top of
// the featured list (in order); the remaining slots are auto-filled with the
// most-recently-touched examples in the examples repo. Leave empty for a
// fully dynamic featured row driven entirely by recent git activity.
export const featuredOverride: string[] = [];

export const featuredCount = 8;
